(() => {
  const root = document.querySelector(".oh-egypt-order");
  if (!root || root.dataset.ready === "1") return;
  root.dataset.ready = "1";
  const cartCheckoutMode = root.dataset.checkoutMode === "cart";

  const locale = root.dataset.locale === "en" ? "en" : "ar";
  const isAr = locale === "ar";
  const t = isAr ? {
    genericError:"تعذر إتمام الطلب.", cartLoad:"تعذر تحميل سلة التسوق.", emptyCart:"سلة التسوق فارغة.",
    codTitle:"الدفع عند الاستلام", codDesc:"الدفع لمندوب الشحن عند استلام الطلب", cardTitle:"فيزا أو بطاقة", cardDesc:"الدفع الآمن بالبطاقة البنكية",
    qrTitle:"الدفع بالباركود", qrDesc:"امسح الباركود وأتم التحويل", fullName:"اكتب الاسم الكامل.", phone:"اكتب رقم هاتف مصري صحيح.",
    city:"اختر محافظة من القائمة.", area:"اكتب المنطقة أو المدينة.", address:"اكتب العنوان بالتفصيل.", reference:"اكتب رقم عملية التحويل.", redirecting:"جاري التحويل...",
    confirming:"جاري تأكيد الطلب...", confirm:"تأكيد الطلب", confirmWithTotal:(total)=>`تأكيد الطلب — ${money(total)}`, success:(name)=>`تم استلام طلبك بنجاح ✅ رقم الطلب: ${name}`,
    editCart:"تعديل السلة", timeout:"استغرق الطلب وقتًا طويلاً. تحقق من اتصالك وحاول مرة أخرى.", stillProcessing:"طلبك قيد المعالجة بالفعل، الرجاء الانتظار قليلاً ثم إعادة المحاولة."
  } : {
    genericError:"We could not complete your order.", cartLoad:"We could not load your cart.", emptyCart:"Your cart is empty.",
    codTitle:"Cash on delivery", codDesc:"Pay the delivery courier when your order arrives", cardTitle:"Visa / Card", cardDesc:"Secure payment by bank card",
    qrTitle:"QR payment", qrDesc:"Scan the code and complete the transfer", fullName:"Enter your full name.", phone:"Enter a valid Egyptian phone number.",
    city:"Choose a governorate from the list.", area:"Enter your area or city.", address:"Enter your detailed address.", reference:"Enter the transfer reference.", redirecting:"Redirecting...",
    confirming:"Confirming your order...", confirm:"Confirm order", confirmWithTotal:(total)=>`Confirm order — ${money(total)}`, success:(name)=>`Order received successfully ✅ Order: ${name}`,
    editCart:"Edit cart", timeout:"That took too long. Check your connection and try again.", stillProcessing:"Your order is already being processed. Please wait a moment and try again."
  };

  const q = (selector) => root.querySelector(selector);

  // Keep the native Dawn cart wording clear: checkout here opens the order form,
  // it does not take payment yet.
  function localizeNativeCart() {
    if (!isAr) return;
    const replacements = new Map([
      ["عربة التسوق الخاصة بك", "سلتك"],
      ["الإجمالي المقدر", "إجمالي الطلب"],
      ["الدفع", "إتمام الطلب"],
    ]);
    // Dawn can render Arabic with optional vowel marks, so compare a normalized
    // value rather than relying on an exact character-for-character match.
    const normalizeArabic = (value) => String(value || "")
      .replace(/[\u064B-\u065F\u0670]/g, "")
      .replace(/ٱ/g, "ا")
      .replace(/\s+/g, " ")
      .trim();
    const roots = document.querySelectorAll("cart-drawer, #CartDrawer");
    roots.forEach((drawer) => {
      const walker = document.createTreeWalker(drawer, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        const original = String(node.nodeValue || "");
        const textValue = original.trim();
        const normalized = normalizeArabic(textValue);
        const replacement = replacements.get(textValue)
          || (["الإجمالي المقدر", "الاجمالي المقدر"].includes(normalized) ? "إجمالي الطلب" : "");
        if (!replacement) return;
        node.nodeValue = original.replace(textValue, replacement);
      });
    });
  }
  // Dawn refreshes the cart drawer asynchronously after a cart change. Watch
  // for that render and apply the Arabic storefront terms every time it appears.
  let cartWordingTimer;
  const scheduleNativeCartLocalization = () => {
    clearTimeout(cartWordingTimer);
    cartWordingTimer = setTimeout(localizeNativeCart, 0);
  };
  if (isAr && typeof MutationObserver !== "undefined") {
    const drawer = document.querySelector("cart-drawer");
    if (drawer) new MutationObserver(scheduleNativeCartLocalization)
      .observe(drawer, { childList: true, subtree: true });
  }
  scheduleNativeCartLocalization();

  const status = q("[data-status]"), app = q("[data-app]"), form = q("[data-form]");
  const result = q("[data-result]"), successSummary = q("[data-success-summary]"), submit = q("[data-submit]"), stickySubmit = q("[data-sticky-submit]"), paymentOptions = q("[data-payment-options]");
  const editCartBtn = q("[data-edit-cart]");
  const proxy = String(root.dataset.proxyRoot).replace(/\/$/, "");
  const enableAbandonedCapture = root.dataset.enableAbandoned !== "false";
  const showEditCart = root.dataset.showEditCart !== "false";
  const REQUEST_TIMEOUT_MS = 20000;
  const ATTEMPT_STORAGE_KEY = "orderhub_egypt_attempt_v1";

  const fallbackAttemptId = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => { const n = Math.floor(Math.random() * 16); return (c === "x" ? n : (n & 3) | 8).toString(16); });
  const newUuid = () => (typeof crypto?.randomUUID === "function" ? crypto.randomUUID() : fallbackAttemptId());

  // --- Idempotent attempt id -------------------------------------------------
  // Persisted so a page refresh, mobile "resume", or back/forward restore
  // reuses the SAME attemptId (and therefore the SAME server-side
  // CheckoutAttempt row) instead of minting a brand new one. A brand new id
  // on every load is what allowed retries/refreshes to bypass the backend's
  // own idempotency table. The stored attempt is only reused while it is
  // still tied to the exact same cart (by Shopify's cart token); if the cart
  // has changed we deliberately start a fresh attempt so we never show a
  // stale order as if it belonged to the current cart.
  function readStoredAttempt() {
    try {
      const raw = sessionStorage.getItem(ATTEMPT_STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.attemptId !== "string" || typeof parsed.cartFingerprint !== "string") return null;
      return parsed;
    } catch (_) { return null; }
  }
  function writeStoredAttempt(id, cartFingerprint) {
    try { sessionStorage.setItem(ATTEMPT_STORAGE_KEY, JSON.stringify({ attemptId: id, cartFingerprint, ts: Date.now() })); } catch (_) {}
  }
  function clearStoredAttempt() {
    try { sessionStorage.removeItem(ATTEMPT_STORAGE_KEY); } catch (_) {}
  }

  const abandonedKey = "orderhub_egypt_abandoned_session";
  let abandonedSessionId = "";
  let abandonedCompleted = false;
  let abandonedCompletedCartFingerprint = "";
  let cart, trusted, sending = false, abandonedTimer;
  let trustedCartFingerprint = "";
  let trustedCity = "";
  let attemptId = newUuid(); // replaced once the cart is known, see resolveAttemptId()
  let validateSeq = 0;
  let validateAbort = null;

  let enabledGovernorates = [];
  const isGovernorate = (value) => enabledGovernorates.some((item) => item.value === String(value || "").trim());
  function governorateByCode(value) {
    const code = String(value || "").trim();
    return enabledGovernorates.find((item) => item.value === code) || null;
  }

  function governorateName(value) {
    const item = governorateByCode(value);
    return String(item?.nameEn || item?.nameAr || item?.label || value || "").trim();
  }

  function renderGovernorates() {
    // OrderHub MarketShippingRate is the single source of truth for Egypt.
    // Only enabled rows are visible; the option value is always regionCode.
    const regions = Array.isArray(trusted?.marketConfig?.regions) ? trusted.marketConfig.regions : [];
    enabledGovernorates = regions
      .filter((item) => item?.enabled !== false && String(item?.code || "").trim())
      .map((item) => {
        const value = String(item.code || "").trim();
        const nameEn = String(item.nameEn || value).trim();
        const nameAr = String(item.nameAr || nameEn).trim();
        return {
          value,
          nameEn,
          nameAr,
          label: String((isAr ? nameAr : nameEn) || nameEn || nameAr || value).trim(),
        };
      })
      .filter((item) => item.value && item.label);

    const cityField = form?.elements?.city;
    const selected = String(cityField?.value || "").trim();
    if (selected && !isGovernorate(selected)) cityField.value = "";

    const select = q("[data-governorate-select]");
    if (select) {
      select.innerHTML = `<option value="">${isAr ? "اختر المحافظة" : "Select governorate"}</option>` + enabledGovernorates.map((item) => `<option value="${esc(item.value)}">${esc(item.label)}</option>`).join("");
      select.value = isGovernorate(selected) ? selected : "";
      select.onchange = async () => {
        const choice = String(select.value || "");
        if (!isGovernorate(choice)) return;
        try { const applied = await validate(choice); if (applied) { renderSummary(); renderPayments(); result.hidden = true; } } catch (error) { message(error.message); }
      };
      return;
    }

    const search = q("[data-governorate-search]");
    const options = q("[data-governorate-options]");
    if (!search || !options) return;
    if (!isGovernorate(selected)) search.value = "";
    const draw = () => {
      const needle = search.value.trim().toLowerCase();
      const matches = enabledGovernorates.filter((item) => !needle || item.label.toLowerCase().includes(needle));
      options.innerHTML = matches.map((item) => `<button type="button" role="option" data-governorate-value="${esc(item.value)}">${esc(item.label)}</button>`).join("") || `<p>${isAr ? "لا توجد محافظة مطابقة" : "No matching governorate"}</p>`;
      options.hidden = false; search.setAttribute("aria-expanded", "true");
    };
    search.onfocus = draw;
    search.oninput = () => { cityField.value = ""; draw(); };
    search.onblur = () => setTimeout(() => {
      if (search.value !== String(cityField.value || "")) search.value = governorateByCode(cityField.value)?.label || "";
      options.hidden = true; search.setAttribute("aria-expanded", "false");
    }, 150);
    options.onclick = async (event) => {
      const choice = event.target?.closest?.("[data-governorate-value]")?.dataset.governorateValue;
      if (!choice || !isGovernorate(choice)) return;
      cityField.value = choice; search.value = governorateByCode(choice)?.label || choice; options.hidden = true; search.setAttribute("aria-expanded", "false");
      try { const applied = await validate(choice); if (applied) { renderSummary(); renderPayments(); result.hidden = true; } } catch (error) { message(error.message); }
    };
  }

  const addressWithArea = (area, address) => [String(area || "").trim(), String(address || "").trim()].filter(Boolean).join(" · ");

  const money = (amount) => new Intl.NumberFormat(isAr ? "ar-EG" : "en-EG", { style: "currency", currency: "EGP", maximumFractionDigits: 0 }).format(Number(amount || 0));
  const esc = (value) => String(value || "").replace(/[&<>"']/g, (c) => ({ "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;", "'":"&#039;" })[c]);
  const message = (text, bad = true) => { result.hidden = false; result.className = "oh-egypt-order__result " + (bad ? "oh-egypt-order__result--bad" : "oh-egypt-order__result--ok"); result.textContent = text; };

  // Show the shopper exactly which required field needs attention. Governorate
  // is stored in a hidden form field, so its visible select is the focus target.
  function validationTarget(field) {
    if (!field) return null;
    return field.name === "city" ? (q("[data-governorate-select]") || q("[data-governorate-search]") || field) : field;
  }
  function clearInvalid(field) {
    const target = validationTarget(field);
    if (!target) return;
    target.classList.remove("is-invalid");
    target.removeAttribute("aria-invalid");
  }
  function markInvalid(field, text) {
    const target = validationTarget(field);
    clearInvalid(field);
    if (target) {
      target.classList.add("is-invalid");
      target.setAttribute("aria-invalid", "true");
      target.scrollIntoView({ behavior: "smooth", block: "center" });
      setTimeout(() => target.focus({ preventScroll: true }), 180);
    }
    message(text);
  }
  form?.addEventListener("input", (event) => clearInvalid(event.target));
  form?.addEventListener("change", (event) => clearInvalid(event.target));

  function resolveAttemptId(fingerprint) {
    const stored = readStoredAttempt();
    if (stored && stored.cartFingerprint === fingerprint) {
      attemptId = stored.attemptId;
    } else {
      attemptId = newUuid();
      writeStoredAttempt(attemptId, fingerprint);
    }
  }

  // Identity of "the same cart" for idempotency purposes: the actual line
  // items (variant + quantity), NOT the Shopify cart token. The token
  // identifies the cart *session* and can stay identical even after the
  // shopper edits quantities or swaps a variant, so keying off the token
  // alone would incorrectly resume a stale attempt for now-different
  // contents. Order is normalized (sorted) so re-fetching the same cart in
  // a different item order still matches.
  function cartFingerprint(cartObj) {
    return (cartObj.items || [])
      .map((item) => `${item.variant_id}:${item.quantity}`)
      .sort()
      .join("|");
  }

  function pixelConfig() {
    return trusted?.marketConfig || {};
  }

  function trackPixel(eventName, payload = {}, onceKey = "", eventId = "") {
    const config = pixelConfig();
    if (!config.pixelEnabled || !config.metaPixelId || typeof window.fbq !== "function") return;
    try {
      if (onceKey) {
        const key = `orderhub_pixel_${onceKey}`;
        if (sessionStorage.getItem(key) === "1") return;
        sessionStorage.setItem(key, "1");
      }
      window.fbq("trackSingle", String(config.metaPixelId), eventName, payload, eventId ? { eventID: String(eventId) } : undefined);
    } catch (_) {}
  }

  function pixelContents() {
    return (trusted?.lines || []).map((line) => ({
      id: String(line.variantId || "").split("/").pop(),
      quantity: Number(line.quantity || 0),
      item_price: Number(line.unitPrice || 0),
    }));
  }

  function withTimeout(signal, ms) {
    // Combine a caller-provided AbortSignal (used for sequencing/cancellation)
    // with a hard timeout, so a hung request can never keep the UI stuck.
    const controller = new AbortController();
    const onAbort = () => controller.abort();
    if (signal) { if (signal.aborted) controller.abort(); else signal.addEventListener("abort", onAbort); }
    const timer = setTimeout(() => controller.abort(), ms);
    return { signal: controller.signal, cancel: () => { clearTimeout(timer); signal?.removeEventListener("abort", onAbort); } };
  }

  async function api(path, options = {}, signal) {
    const guard = withTimeout(signal, REQUEST_TIMEOUT_MS);
    try {
      const response = await fetch(path, { credentials: "same-origin", headers: { "Content-Type": "application/json" }, ...options, signal: guard.signal });
      const data = await response.json().catch(() => null);
      if (!response.ok || !data?.ok) throw new Error(data?.error?.message || data?.error?.code || t.genericError);
      return data.data;
    } catch (error) {
      if (error?.name === "AbortError") throw new Error(t.timeout);
      throw error;
    } finally { guard.cancel(); }
  }

  async function getCart() {
    const guard = withTimeout(null, REQUEST_TIMEOUT_MS);
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, { credentials: "same-origin", signal: guard.signal });
      if (!response.ok) throw new Error(t.cartLoad);
      return await response.json();
    } catch (error) {
      if (error?.name === "AbortError") throw new Error(t.timeout);
      throw error;
    } finally { guard.cancel(); }
  }

  // Dawn may update its cart bubble before cart.js has caught up in the Theme
  // Editor. For a product-page quick order, use the currently selected variant
  // as a safe fallback; the server still validates its price and availability.
  function selectedProductFallback() {
    const productForm = document.querySelector('form[action*="/cart/add"]') || document.querySelector('product-form form');
    const variantId = String(productForm?.querySelector('[name="id"]')?.value || root.dataset.productVariantId || "").trim();
    if (!/^\\d+$/.test(variantId)) return null;
    const quantity = Math.max(1, Number(productForm?.querySelector('[name="quantity"]')?.value || 1));
    const title = String(document.querySelector("h1")?.textContent || "Product").trim();
    return { items: [{ variant_id: Number(variantId), quantity, product_title: title, title }] };
  }

  async function getOrderCart() {
    const liveCart = await getCart();
    return liveCart?.items?.length ? liveCart : (selectedProductFallback() || liveCart);
  }

  const linesPayload = () => cart.items.map((item) => ({ variantId: `gid://shopify/ProductVariant/${item.variant_id}`, quantity: item.quantity }));

  // Request-sequencing: only the response to the LATEST validate() call is
  // ever allowed to update state/UI. City switched quickly A -> B -> C: if
  // B's response arrives after C's (out-of-order network), it is discarded.
  async function validate(city = "") {
    const seq = ++validateSeq;
    validateAbort?.abort();
    const controller = new AbortController();
    validateAbort = controller;
    try {
      const provinceName = governorateName(city);
      const data = await api(`${proxy}/validate`, { method:"POST", body:JSON.stringify({ lineItems: linesPayload(), shippingAddress: city ? { provinceCode: city, province: provinceName, city: provinceName } : undefined }) }, controller.signal);
      if (seq !== validateSeq) return false; // a newer validate() has since started; discard this stale result
      trusted = data;
      trustedCartFingerprint = cartFingerprint(cart || {});
      trustedCity = city || "";
      return true;
    } catch (error) {
      // If a newer validate() has since started, this call was deliberately
      // cancelled (or simply superseded) because the user picked another
      // governorate in the meantime — that is expected and must be silent,
      // never surfaced as a "timeout" to the user. Only a genuine failure of
      // the LATEST request should ever reach the caller.
      if (seq !== validateSeq) return false;
      throw error;
    }
  }

  function cardCheckoutUrl({ fullName, phone, city, area, address1 }) {
    const parts = fullName.split(/\s+/).filter(Boolean);
    const firstName = parts.shift() || fullName;
    const lastName = parts.join(" ") || firstName;
    const cartPath = cart.items.map((item) => `${item.variant_id}:${item.quantity}`).join(",");
    const localPhone = phone;
    const internationalPhone = `+20${phone.slice(1)}`;
    const params = new URLSearchParams();
    params.set("checkout[shipping_address][first_name]", firstName);
    params.set("checkout[shipping_address][last_name]", lastName);
    params.set("checkout[shipping_address][address1]", address1);
    params.set("checkout[shipping_address][city]", area);
    params.set("checkout[shipping_address][province]", city);
    params.set("checkout[shipping_address][country]", "Egypt");
    params.set("checkout[shipping_address][phone]", localPhone);
    params.set("checkout[phone]", internationalPhone);
    params.set("checkout[email_or_phone]", localPhone);
    params.set("attributes[orderhub_payment_method]", "CARD");
    params.set("attributes[orderhub_phone]", internationalPhone);
    params.set("attributes[orderhub_market]", "EG");
    const recoverySessionId = sessionForAbandonedCapture();
    if (recoverySessionId) params.set("attributes[orderhub_abandoned_session_id]", recoverySessionId);
    return `${window.location.origin}/cart/${cartPath}?${params.toString()}`;
  }

  function syncSubmitLabels() {
    const hasShipping = String(form?.elements?.city?.value || "").trim() && trustedCity === String(form.elements.city.value);
    const label = trusted && hasShipping ? t.confirmWithTotal(trusted.total) : t.confirm;
    if (!sending) submit.textContent = label;
    if (stickySubmit) { stickySubmit.textContent = label; stickySubmit.hidden = false; }
  }

  function renderSummary() {
    renderGovernorates();
    const byId = new Map(cart.items.map((item) => [`gid://shopify/ProductVariant/${item.variant_id}`, item]));
    q("[data-lines]").innerHTML = trusted.lines.map((line) => {
      const item = byId.get(line.variantId) || {}, image = item.image || item.featured_image?.url || "";
      return `<div class="oh-egypt-order__line">${image ? `<img src="${esc(image)}" alt="" loading="lazy">` : ""}<div><strong>${esc(line.title)}</strong><small>${esc(line.variantTitle)}</small><span>${line.quantity} × ${money(line.unitPrice)}</span></div><b>${money(line.quantity * line.unitPrice)}</b></div>`;
    }).join("");
    q("[data-subtotal]").textContent = money(trusted.subtotal);
    q("[data-shipping]").textContent = String(form?.elements?.city?.value || "").trim()
      ? money(trusted.shipping) : window.OrderHubThemeStrings.shippingPending;
    q("[data-total]").textContent = money(trusted.total);
    const shippingPreview = q("[data-shipping-preview]");
    const shippingPreviewValue = q("[data-shipping-preview-value]");
    const selectedCity = String(form?.elements?.city?.value || "");
    if (shippingPreview && shippingPreviewValue) {
      shippingPreview.hidden = !selectedCity;
      shippingPreviewValue.textContent = money(trusted.shipping);
    }
    syncSubmitLabels();
  }

  function renderPayments() {
    const methods = trusted.paymentMethods || ["COD"];
    const titles = {
      COD:[t.codTitle, t.codDesc],
      CARD:[t.cardTitle, t.cardDesc],
      QR:[t.qrTitle, t.qrDesc]
    };
    const current = form.elements.paymentMethod?.value;
    paymentOptions.innerHTML = methods.map((method, index) => `<label class="oh-egypt-order__payment"><input type="radio" name="paymentMethod" value="${method}" ${current === method || (!current && index === 0) ? "checked" : ""}><span><strong>${titles[method][0]}</strong><small>${titles[method][1]}</small></span></label>`).join("");

    const qr = q("[data-qr]"), config = trusted.marketConfig || {}, ref = form.elements.paymentReference;
    q("[data-qr-title]").textContent = isAr ? (config.qrTitleAr || t.qrTitle) : (config.qrTitleEn || t.qrTitle);
    q("[data-qr-instructions]").textContent = isAr ? (config.qrInstructionsAr || "") : (config.qrInstructionsEn || config.qrInstructionsAr || "");
    const qrImage = q("[data-qr-image]");
    if (config.qrImageUrl) { qrImage.src = config.qrImageUrl; qrImage.hidden = false; }
    else qrImage.hidden = true;

    const syncQr = () => {
      const isQr = form.elements.paymentMethod?.value === "QR";
      qr.hidden = !isQr;
      ref.required = isQr && config.qrReferenceRequired !== false;
    };
    paymentOptions.onchange = syncQr;
    syncQr();
  }

  function openCartDrawer() {
    // Best-effort: works with Dawn's <cart-drawer> custom element, falls
    // back to clicking a visible cart trigger, and finally to /cart. This is
    // additive UI only — it never touches checkout/confirm submission logic.
    try {
      const drawer = document.querySelector("cart-drawer, #CartDrawer");
      if (drawer && typeof drawer.open === "function") { drawer.open(); return; }
      const trigger = document.querySelector("[data-cart-drawer-toggle], a[href$='/cart']:not(.oh-egypt-order__edit-cart), .cart-icon-bubble, #cart-icon-bubble");
      if (trigger && typeof trigger.click === "function") { trigger.click(); return; }
    } catch (_) {}
    window.location.href = `${window.Shopify.routes.root}cart`;
  }

  function closeNativeCartDrawer(cartWasCleared = false) {
    // Closing the drawer must not alter its count during ordinary "Continue
    // shopping" or "Edit cart" actions. The badge is removed only after a
    // confirmed cart/clear.js response.
    try {
      const drawer = document.querySelector("cart-drawer, #CartDrawer");
      if (drawer && typeof drawer.close === "function") drawer.close();
      drawer?.classList.remove("active", "is-open", "open");
      document.body.classList.remove("overflow-hidden");
      document.documentElement.classList.remove("overflow-hidden");
      if (cartWasCleared) document.querySelectorAll(".cart-count-bubble").forEach((bubble) => bubble.remove());
    } catch (_) {}
  }

  function renderEditCart() {
    if (!editCartBtn) return;
    if (!showEditCart) { editCartBtn.hidden = true; return; }
    editCartBtn.hidden = false;
    editCartBtn.textContent = t.editCart;
    editCartBtn.onclick = (event) => {
      event.preventDefault();
      // Editing is a separate surface: never leave the checkout modal layered
      // on top of Dawn's drawer.
      closeCartCheckout();
      openCartDrawer();
    };
  }

  // A completed COD order is marked CONVERTED on the server. Never reuse that
  // identifier for the shopper's next cart: doing so makes the server correctly
  // return the old converted row and hides the new checkout from Active.
  function sessionForAbandonedCapture() {
    const fingerprint = cartFingerprint(cart || {});
    if (abandonedCompleted) {
      // Do not mint a new recovery id for the same cart after a successful
      // order. A genuinely different cart starts a new recovery lifecycle.
      if (!fingerprint || fingerprint === abandonedCompletedCartFingerprint) return "";
      abandonedCompleted = false;
      abandonedCompletedCartFingerprint = "";
    }
    if (abandonedSessionId) return abandonedSessionId;
    try {
      const stored = JSON.parse(localStorage.getItem(abandonedKey) || "null");
      if (stored && /^[0-9a-f-]{36}$/i.test(stored.id || "") && stored.cartFingerprint === fingerprint) {
        abandonedSessionId = stored.id;
      } else {
        abandonedSessionId = newUuid();
        localStorage.setItem(abandonedKey, JSON.stringify({ id: abandonedSessionId, cartFingerprint: fingerprint }));
      }
    } catch (_) {
      abandonedSessionId = newUuid();
    }
    return abandonedSessionId;
  }

  function resetAbandonedSession() {
    abandonedCompleted = true;
    abandonedCompletedCartFingerprint = cartFingerprint(cart || {});
    clearTimeout(abandonedTimer);
    abandonedTimer = null;
    abandonedSessionId = "";
    try { localStorage.removeItem(abandonedKey); } catch (_) {}
  }

  function queueAbandonedCapture() {
    if (!enableAbandonedCapture || abandonedCompleted) return;
    clearTimeout(abandonedTimer);
    abandonedTimer = setTimeout(async () => {
      if (abandonedCompleted) return;
      // Non-blocking by construction: fire-and-forget, wrapped in try/catch,
      // never awaited by the checkout/confirm path.
      const phone = String(form.elements.phone?.value || "").replace(/\D/g, "");
      const fullName = String(form.elements.fullName?.value || "").trim();
      if (!/^01[0125]\d{8}$/.test(phone) || fullName.length < 2 || !cart?.items?.length || !trusted) return;
      const city = String(form.elements.city?.value || "");
      const area = String(form.elements.area?.value || "").trim();
      const address1 = addressWithArea(area, form.elements.address1?.value || "");
      const paymentMethod = String(form.elements.paymentMethod?.value || "COD");
      try {
        await api(`${proxy}/abandoned`, { method: "POST", body: JSON.stringify({
          abandonedSessionId: sessionForAbandonedCapture(),
          customer: { fullName, phone },
          shippingAddress: { city, address1 },
          paymentMethod,
          lineItems: trusted.lines || [],
          subtotal: Number(trusted.subtotal || 0),
          shipping: Number(trusted.shipping || 0),
          total: Number(trusted.total || 0),
          sourceUrl: window.location.href,
        }) });
      } catch (error) {
        // Dev-store-only diagnostic: production shoppers never see recovery
        // transport details, but preview testing must not silently hide them.
        if (window.location.hostname.includes("shoppingooo-iraq-dev")) {
          message(`Recovery capture failed: ${error?.message || "unknown error"}`);
        }
      }
    }, 1200);
  }

  async function clearCartAndMaybeForgetAttempt(shouldClear) {
    // Clear is verified, not assumed. Some Dawn/cart sessions acknowledge
    // cart/clear.js late; in that case retry by explicitly setting every
    // current line to zero, then read cart.js again before finishing.
    if (!shouldClear) return false;
    const cartRoot = window.Shopify.routes.root;
    const postJson = async (path, body) => {
      const response = await fetch(path, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(body),
      });
      return response.ok;
    };
    try {
      await postJson(`${cartRoot}cart/clear.js`, {});
      let liveCart = await getCart();
      if (liveCart.items?.length) {
        const updates = Object.fromEntries(liveCart.items.map((item) => [String(item.variant_id), 0]));
        await postJson(`${cartRoot}cart/update.js`, { updates });
        liveCart = await getCart();
      }
      if (liveCart.items?.length) return false;

      clearStoredAttempt();
      cart = { ...(cart || {}), items: [], item_count: 0, total_price: 0 };
      closeNativeCartDrawer(true);
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
      return true;
    } catch (_) {
      // Keep the idempotency key if Shopify is unreachable; a retry cannot
      // accidentally create a second order against an uncleared cart.
      return false;
    }
  }

  function showCompletedOrder(orderName) {
    const paymentMethod = String(form.elements.paymentMethod?.value || "COD");
    const paymentLabel = ({ COD: t.codTitle, CARD: t.cardTitle, QR: t.qrTitle })[paymentMethod] || paymentMethod;
    form.hidden = true;
    if (stickySubmit) stickySubmit.hidden = true;
    if (editCartBtn) editCartBtn.hidden = true;
    root.dataset.completed = "1";
    if (root.dataset.showSuccess !== "false") message(t.success(orderName), false);
    if (!successSummary) return;
    successSummary.innerHTML = `<h3>${isAr ? "مراجعة طلبك" : "Your order summary"}</h3>
      <div class="oh-egypt-order__summary-lines">${q("[data-lines]")?.innerHTML || ""}</div>
      <div class="oh-egypt-order__totals">
        <div><span>${isAr ? "المجموع" : "Subtotal"}</span><strong>${money(trusted?.subtotal)}</strong></div>
        <div><span>${isAr ? "التوصيل" : "Shipping"}</span><strong>${money(trusted?.shipping)}</strong></div>
        <div class="oh-egypt-order__grand"><span>${isAr ? "الإجمالي" : "Total"}</span><strong>${money(trusted?.total)}</strong></div>
      </div>
      <div class="oh-egypt-order__payment-summary"><span>${isAr ? "طريقة الدفع" : "Payment method"}</span><strong>${esc(paymentLabel)}</strong></div>
      <button type="button" class="oh-egypt-order__success-close" data-success-close>${isAr ? "إغلاق" : "Close"}</button>`;
    successSummary.hidden = false;
    successSummary.querySelector("[data-success-close]")?.addEventListener("click", closeCartCheckout, { once: true });
  }

  function finishSuccessfulCheckout() {
    // The form is replaced by a final read-only receipt. It cannot submit again.
  }

  async function recoverCreatedOrder() {
    try {
      const recovered = await api(`${proxy}/order-status?attemptId=${encodeURIComponent(attemptId)}`);
      if (recovered.status !== "CREATED") return false;
      status.hidden = true;
      status.style.display = "none";
      app.hidden = false;
      resetAbandonedSession();
      await clearCartAndMaybeForgetAttempt(true);
      showCompletedOrder(recovered.orderName);
      finishSuccessfulCheckout();
      return true;
    } catch (_) {
      return false; // no recoverable order status (e.g. attempt never reached the server) — proceed normally
    }
  }

  // Dawn updates the drawer independently of this app block. Keep the
  // summary in sync after quantity/remove actions without trusting its old UI.
  let cartSyncTimer;
  async function syncCartFromStore(forceValidate = false) {
    if (sending || root.dataset.completed === "1") return;
    try {
      const nextCart = await getOrderCart();
      const cartChanged = cartFingerprint(nextCart) !== cartFingerprint(cart || {});
      const selectedCity = String(form.elements.city?.value || "");
      // Reopening after Visa/back must recalculate shipping for the selected
      // governorate even when the line items themselves did not change.
      if (!cartChanged && !forceValidate && trusted && trustedCity === selectedCity) return;
      cart = nextCart;
      if (!cart.items?.length) {
        clearStoredAttempt();
        window.location.reload();
        return;
      }
      if (cartChanged) resolveAttemptId(cartFingerprint(cart));
      const applied = await validate(selectedCity);
      if (applied) {
        renderSummary();
        renderPayments();
        result.hidden = true;
      }
    } catch (_) {
      // The next confirmed submit always reloads cart + validates server-side.
    }
  }
  function queueCartSync() {
    clearTimeout(cartSyncTimer);
    cartSyncTimer = setTimeout(syncCartFromStore, 800);
  }

  function warmCartCheckout() {
    if (!cartCheckoutMode || root.dataset.loaded === "1" || sending) return;
    // Same safe read/validate path used by the visible form, just started
    // while the shopper is still viewing the cart rather than after Checkout.
    queueCartSync();
  }

  async function load() {
    localizeNativeCart();
    try {
      cart = await getOrderCart();
      if (!cart.items?.length) {
        // An empty cart can no longer resume anything — forget any stale
        // attempt rather than leaving an orphaned entry in storage.
        clearStoredAttempt();
        throw new Error(t.emptyCart);
      }
      resolveAttemptId(cartFingerprint(cart));

      // Handles refresh / back-forward restore that lands AFTER a successful
      // order: instead of re-showing an empty form, resolve straight to the
      // success screen for the same attempt.
      if (await recoverCreatedOrder()) return;

      const currentFingerprint = cartFingerprint(cart);
      // A background warm-up may already have obtained this exact cart's
      // validated total. Reuse it for instant opening; submit still validates
      // again on the server before an order is ever created.
      if (!trusted || trustedCartFingerprint !== currentFingerprint || trustedCity !== "") await validate();
      renderSummary(); renderPayments(); renderEditCart();
      const config = pixelConfig();
      if (config.initiateCheckout !== false) {
        trackPixel("InitiateCheckout", {
          value: Number(trusted.total || 0),
          currency: "EGP",
          content_type: "product",
          contents: pixelContents(),
          num_items: pixelContents().reduce((sum, item) => sum + Number(item.quantity || 0), 0),
        }, `initiate_${attemptId}`);
      }
      setTimeout(renderGovernorates, 350);
      // Capture both normal typing and browser autofill: some browsers only
      // emit change/focusout for autofilled values, not input.
      ["fullName", "phone", "area", "address1"].forEach((name) => {
        const field = form.elements[name];
        field?.addEventListener("input", queueAbandonedCapture);
        field?.addEventListener("change", queueAbandonedCapture);
        field?.addEventListener("blur", queueAbandonedCapture);
      });
      form.elements.city.addEventListener("change", queueAbandonedCapture);
      // Make an immediate best-effort capture when the shopper leaves the page.
      window.addEventListener("pagehide", () => {
        if (!enableAbandonedCapture || abandonedCompleted) return;
        const phone = String(form.elements.phone?.value || "").replace(/\\D/g, "");
        const fullName = String(form.elements.fullName?.value || "").trim();
        if (!/^01[0125]\\d{8}$/.test(phone) || fullName.length < 2 || !cart?.items?.length || !trusted || !navigator.sendBeacon) return;
        const city = String(form.elements.city?.value || "");
        const area = String(form.elements.area?.value || "").trim();
        const address1 = addressWithArea(area, form.elements.address1?.value || "");
        const recoverySessionId = sessionForAbandonedCapture();
        if (!recoverySessionId) return;
        const payload = {
          abandonedSessionId: recoverySessionId,
          customer: { fullName, phone },
          shippingAddress: { city, address1 },
          paymentMethod: String(form.elements.paymentMethod?.value || "COD"),
          lineItems: trusted.lines || [],
          subtotal: Number(trusted.subtotal || 0),
          shipping: Number(trusted.shipping || 0),
          total: Number(trusted.total || 0),
          sourceUrl: window.location.href,
        };
        navigator.sendBeacon(`${proxy}/abandoned`, new Blob([JSON.stringify(payload)], { type: "application/json" }));
      });
      status.hidden = true; app.hidden = false;
      // Browser autofill may have populated name/phone before listeners were
      // attached. Capture those already-present valid details as well.
      queueAbandonedCapture();
    } catch (error) { status.textContent = error.message; }
  }

  stickySubmit?.addEventListener("click", () => form.requestSubmit());

  // Support Dawn's cart controls and themes that emit cart lifecycle events.
  document.addEventListener("click", (event) => {
    const target = event.target;
    if (target?.closest?.("cart-drawer, #CartDrawer")) warmCartCheckout();
    // Prime the form shortly after Dawn has added an item to the cart.
    if (target?.closest?.('form[action*="/cart/add"] button[type="submit"], product-form button[type="submit"]')) {
      setTimeout(warmCartCheckout, 900);
    }
  });
  document.addEventListener("change", (event) => {
    if (event.target?.closest?.("cart-drawer, #CartDrawer")) queueCartSync();
  });
  ["cart:updated", "cart:refresh", "cart:change"].forEach((eventName) => {
    document.addEventListener(eventName, () => { localizeNativeCart(); queueCartSync(); });
  });

  // Dawn's default "Continue shopping" link can navigate to the home page.
  // Inside this Cart Drawer it should simply dismiss the drawer and preserve
  // the product page the shopper was already viewing.
  document.addEventListener("click", (event) => {
    const link = event.target?.closest?.("cart-drawer a[href], #CartDrawer a[href]");
    if (!link || !/continue\s+shopping/i.test(link.textContent || "")) return;
    event.preventDefault();
    closeNativeCartDrawer();
  });

  form.addEventListener("submit", async (event) => {
    event.preventDefault(); if (sending) return;
    const fd = new FormData(form), fullName = String(fd.get("fullName") || "").trim();
    const phone = String(fd.get("phone") || "").replace(/\D/g, "");
    const city = String(fd.get("city") || "").trim(), area = String(fd.get("area") || "").trim(), address1 = addressWithArea(area, fd.get("address1") || "");
    const paymentMethod = String(fd.get("paymentMethod") || "");
    if (fullName.length < 2) return markInvalid(form.elements.fullName, t.fullName);
    if (!/^01[0125]\d{8}$/.test(phone)) return markInvalid(form.elements.phone, t.phone);
    if (!isGovernorate(city)) return markInvalid(form.elements.city, t.city);
    if (area.length < 2) return markInvalid(form.elements.area, t.area);
    if (String(fd.get("address1") || "").trim().length < 5) return markInvalid(form.elements.address1, t.address);
    if (paymentMethod === "QR" && form.elements.paymentReference.required && !String(fd.get("paymentReference") || "").trim()) return markInvalid(form.elements.paymentReference, t.reference);

    sending = true; submit.disabled = true; if (stickySubmit) stickySubmit.disabled = true; submit.textContent = paymentMethod === "CARD" ? t.redirecting : t.confirming;
    if (root.dataset.enableVibration === "true") {
      root.classList.add("is-confirming");
      if (navigator.vibrate) navigator.vibrate(18);
    }
    try {
      cart = await getOrderCart();
      if (!cart.items?.length) { clearStoredAttempt(); throw new Error(t.emptyCart); }
      resolveAttemptId(cartFingerprint(cart));
      const applied = await validate(city);
      if (applied) renderSummary();

      if (paymentMethod === "CARD") {
        window.location.assign(cardCheckoutUrl({ fullName, phone, city: governorateName(city), area, address1 }));
        return;
      }

      const data = await api(`${proxy}/order`, { method:"POST", body:JSON.stringify({
        checkoutAttemptId: attemptId,
        paymentMethod,
        paymentReference: String(fd.get("paymentReference") || "").trim(),
        customer:{ fullName, phone },
        shippingAddress:{ address1, city: area, province: governorateName(city), provinceCode: city, countryCode:"EG" },
        abandonedSessionId: sessionForAbandonedCapture(),
        lineItems:linesPayload(),
        metaEventId: attemptId,
        eventSourceUrl: window.location.href
      }) });
      if (data.redirectUrl) { window.location.assign(data.redirectUrl); return; }

      const config = pixelConfig();
      if (config.purchaseEvent !== false) {
        trackPixel("Purchase", {
          value: Number(trusted.total || 0),
          currency: "EGP",
          content_type: "product",
          contents: pixelContents(),
          order_id: String(data.orderName || data.orderId || ""),
        }, `purchase_${data.orderId || data.orderName || attemptId}`, attemptId);
      }

      // The order is now converted; the next cart must receive a new recovery session.
      // Expose success only after Shopify has verified the cart is empty and the
      // old attempt has been cleared, so a language reload cannot replay it.
      resetAbandonedSession();
      await clearCartAndMaybeForgetAttempt(true);
      showCompletedOrder(data.orderName);
      finishSuccessfulCheckout();
    } catch (error) {
      try {
        if (paymentMethod !== "CARD" && await recoverCreatedOrder()) return;
      } catch (_) {}
      const isDuplicateInFlight = /DUPLICATE_ATTEMPT/i.test(error?.message || "");
      message(isDuplicateInFlight ? t.stillProcessing : error.message);
      submit.disabled = false; if (stickySubmit) stickySubmit.disabled = false; syncSubmitLabels(); sending = false;
      root.classList.remove("is-confirming");
    }
  });

  function isCheckoutTrigger(target) {
    return target?.closest?.('button[name="checkout"], input[name="checkout"], a[href*="/checkout"], #CartDrawer-Checkout');
  }

  function openCartCheckout() {
    // The COD form owns the viewport; the native drawer must never remain
    // visible behind it, especially on a mobile screen.
    closeNativeCartDrawer();

    // A completed order leaves a success message on screen. If the shopper
    // later builds a new cart, reset that view before reading the new cart.
    if (root.dataset.completed === "1") {
      root.dataset.completed = "0";
      form.reset();
      // Do not carry a prior buyer's values into a new checkout. Browsers can
      // autofill these fields; clearing them after reset keeps each order
      // explicit and prevents a stale city/address from being submitted.
      ["fullName", "phone", "area", "address1", "paymentReference"].forEach((name) => {
        if (form.elements[name]) form.elements[name].value = "";
      });
      if (form.elements.city) form.elements.city.value = "";
      form.hidden = false;
      result.hidden = true;
      if (stickySubmit) stickySubmit.hidden = false;
      renderEditCart();
    }

    root.hidden = false;
    document.documentElement.classList.add("oh-egypt-checkout-open");
    if (root.dataset.loaded !== "1") {
      root.dataset.loaded = "1";
      load();
    } else {
      // Returning from Edit cart must always re-read Shopify's current line
      // items before the customer sees the COD summary again.
      syncCartFromStore(true);
    }
  }

  function closeCartCheckout() {
    root.hidden = true;
    document.documentElement.classList.remove("oh-egypt-checkout-open");
    if (root.dataset.completed === "1") {
      root.dataset.completed = "0";
      root.dataset.loaded = "0";
      form.reset();
      form.hidden = false;
      app.hidden = true;
      result.hidden = true;
      if (successSummary) { successSummary.hidden = true; successSummary.innerHTML = ""; }
      trusted = null; cart = null;
    }
  }

  if (cartCheckoutMode) {
    root.querySelector("[data-close]")?.addEventListener("click", closeCartCheckout);
    document.addEventListener("click", (event) => {
      if (!isCheckoutTrigger(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      openCartCheckout();
    }, true);
    document.addEventListener("submit", (event) => {
      const submitter = event.submitter;
      if (!submitter?.matches?.('[name="checkout"]')) return;
      event.preventDefault();
      event.stopPropagation();
      openCartCheckout();
    }, true);
    const recoveryUrl = new URL(window.location.href);
    if (recoveryUrl.searchParams.get("oh_egypt_checkout") === "1") {
      recoveryUrl.searchParams.delete("oh_egypt_checkout");
      window.history.replaceState({}, "", `${recoveryUrl.pathname}${recoveryUrl.search}${recoveryUrl.hash}`);
      openCartCheckout();
    }
  } else {
    load();
  }
})();
